import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BcSepIcon     from "../../../asset/images/about/breadcrumb-separator.svg";
import HeroBgImg     from "../../../asset/images/power&surveillance/star-tx/hero-bg.webp";
import HeroMobileImg from "../../../asset/images/power&surveillance/star-tx/hero-bg-mobile.webp";
import StarTx1Img    from "../../../asset/images/power&surveillance/star-tx/star-tx-6-40kva.webp";
import StarTx2Img    from "../../../asset/images/power&surveillance/star-tx/star-tx-10-300kva.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .st { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  .st-hero {
    position: relative;
    width: 100%;
    height: 465px;
    overflow: hidden;
    background: #fbe8e7;
  }
  .st-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .st-hero-bg-mobile {
    display: none;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .st-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .st-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #202020;
    line-height: 120%;
    max-width: 524px;
  }
  .st-hero-title em { font-style: normal; color: #EB2019; }

  /* SUBNAV */
  .st-subnav {
    width: 100%;
    background: #EB2019;
    position: sticky;
    top: 162px;
    z-index: 100;
    overflow: visible;
  }
  .st-subnav-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: stretch;
    white-space: nowrap;
    overflow: visible;
  }
  .st-subnav-item {
    position: relative;
    flex-shrink: 0;
  }
  .st-subnav-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s;
    border: 1px solid #A40000;
    background: #B91E1A;
    white-space: nowrap;
    height: 100%;
  }
  .st-subnav-link.st-active { font-weight: 500; }
  .st-subnav-link:hover { background: rgba(0,0,0,0.15); }
  .st-subnav-chevron {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid rgba(255,255,255,0.9);
    border-bottom: 2px solid rgba(255,255,255,0.9);
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .st-subnav-chevron.open { transform: rotate(-135deg) translateY(-2px); }

  /* DROPDOWN — position:absolute */
  .st-subnav-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 312px;
    background: #fff;
    border: 1px solid #7A7A7A;
    z-index: 9999;
  }
  .st-subnav-dropdown-item {
    display: block;
    padding: 15px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    text-decoration: none;
    border-bottom: 1px solid #EB2019;
    transition: background 0.15s;
    cursor: pointer;
  }
  .st-subnav-dropdown-item:last-child { border-bottom: none; }
  .st-subnav-dropdown-item:hover { background: #f9f9f9; color: #EB2019; }
  .st-subnav-dropdown-item.st-dd-active { color: #EB2019; font-weight: 500; }

  /* MOBILE BAR */
  .st-mobile-bar {
    display: none;
    width: 100%;
    background: #B91E1A;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 56px;
    position: sticky;
    top: 72px;
    z-index: 100;
  }
  .st-mobile-bar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .st-hamburger {
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 4px;
  }
  .st-hamburger span {
    display: block;
    width: 22px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
  }

  /* MOBILE SIDEBAR */
  .st-sidebar-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 500;
  }
  .st-sidebar-overlay.open { display: block; }
  .st-sidebar {
    position: fixed;
    top: 80px;
    left: 0;
    width: 275px;
    max-width: 100vw;
    height: 614px;
    background: #fff;
    z-index: 600;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    overflow-y: auto;
    border: 1px solid #7A7A7A;
  }
  .st-sidebar.open { transform: translateX(0); }
  .st-sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #B91E1A;
    padding: 0 20px;
    height: 56px;
    flex-shrink: 0;
  }
  .st-sidebar-header-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .st-sidebar-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #fff;
    font-size: 22px;
    line-height: 1;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .st-sidebar-nav { flex: 1; overflow-y: auto; }
  .st-sidebar-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-bottom: 0.7px solid #7A7A7A;
    cursor: pointer;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    width: 100%;
    text-align: left;
    text-decoration: none;
  }
  .st-sidebar-row:hover { background: #fafafa; }
  .st-sidebar-row.active { color: #000000; font-weight: 400; }
  .st-sidebar-chevron {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-right: 2px solid #888;
    border-bottom: 2px solid #888;
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .st-sidebar-chevron.open { transform: rotate(-135deg) translateY(-2px); }
  .st-sidebar-subitems { border-bottom: 1px solid #efefef; }
  .st-sidebar-subitem {
    display: block;
    padding: 8px 59px 8px 46px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 300;
    color: #202020;
    text-decoration: none;
    border-bottom: 0.7px solid #EB2019;
    cursor: pointer;
  }
  .st-sidebar-subitem:last-child { }
  .st-sidebar-subitem:hover { background: #fafafa; }
  .st-sidebar-subitem.active { color: #B91E1A; font-weight: 400; }

  /* BREADCRUMB */
  .st-breadcrumb { padding: 60px 0 0 0; }
  .st-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
  }
  .st-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .st-bc-item:hover { color: #EB2019; }
  .st-bc-item.active { color: #202020; }
  .st-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* INNER */
  .st-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* DIVIDER */
  .st-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 80px 102px 0px 102px;
  }
  .st-divider hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }
  .st-divider-slim {
    max-width: 1600px;
    margin: 0 auto;
    padding: 60px 102px 0 102px;
  }
  .st-divider-slim hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }

  /* SCROLL ANCHOR */
  .st-anchor { scroll-margin-top: 180px; }

  /* CONTENT */
  .st-section-content { padding: 80px 0 0 0; }
  .st-content-grid {
    display: flex;
    gap: 80px;
    align-items: center;
  }
  .st-content-left { flex: 0 0 766px; }
  .st-img-col {
    flex: 1;
    align-self: stretch;
    background: #F5F5F5;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .st-img-wrap {
    width: 100%;
    height: 100%;
    max-height: 650px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .st-product-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  /* typography */
  .st-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 24px;
    line-height: 120%;
  }
  .st-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
  }
  .st-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #7A7A7A;
    line-height: 140%;
  }
  .st-para + .st-para { margin-top: 14px; }
  .st-features-tag {
    display: inline-flex;
    align-items: stretch;
    margin: 34px 0 34px 0;
  }
  .st-features-tag-bar {
    width: 10px;
    background: #EB2019;
    flex-shrink: 0;
  }
  .st-features-tag-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #202020;
    background: #FFE6E5;
    padding: 18px 27px;
  }
  .st-features-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .st-features-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    padding: 4px 0 4px 20px;
    position: relative;
  }
  .st-features-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #202020;
  }

  /* ══ RESPONSIVE 768px ══ */
  @media (max-width: 768px) {
    .st-hero-bg        { display: block; }
    .st-subnav         { top: 70px; }
    .st-anchor         { scroll-margin-top: 110px; }
    .st-subnav-inner   { padding: 0 16px; overflow-x: auto; }
    .st-subnav-link    { padding: 16px 14px; font-size: 13px; }
    .st-hero              { height: 300px; }
    .st-hero-content      { padding: 0 32px; }
    .st-hero-title        { font-size: 26px; }
    .st-breadcrumb        { padding: 28px 0 0 0; }
    .st-breadcrumb-inner  { padding: 0 24px; }
    .st-inner             { padding: 0 24px; }
    .st-divider           { padding: 0px 32px 0px 32px; }
    .st-divider:last-child { display: none; }
    .st-divider-slim      { padding: 20px 24px 0 24px; }
    .st-section-content   { padding: 40px 0 0 0; }
    .st-content-grid      { flex-direction: column-reverse !important; gap: 30px; }
    .st-content-left      { flex: none; width: 100%; }
    .st-features-tag      { margin: 24px 0 24px 0; }
    .st-features-tag-text { font-size: 14px; padding: 14px 24px; }
    .st-img-col           { min-height: 260px; width: 100%; }
    .st-img-wrap          { max-height: 450px; }
    .st-red-title         { font-size: 24px; margin-bottom: 10px; }
    .st-subtitle          { font-size: 18px; margin-bottom: 10px; }
    .st-para              { font-size: 14px; }
    .st-para + .st-para   { margin-top: 10px; }
    .st-features-list li  { font-size: 14px; }
    .st-content-grid:last-child { margin-bottom: 40px !important; }
  }

  /* ══ RESPONSIVE 480px ══ */
  @media (max-width: 480px) {
    .st-subnav           { display: none; }
    .st-mobile-bar       { display: flex; height: 46px; }
    .st-sidebar-header   { height: 46px; }
    .st-anchor           { scroll-margin-top: 80px; }
    .st-hero-bg          { display: none; }
    .st-hero-bg-mobile   { display: block; }
    .st-hero             { height: 370px; }
    .st-hero-content     { padding: 0 16px; justify-content: flex-start; padding-top: 76px; }
    .st-hero-title       { font-size: 22px; }
    .st-breadcrumb       { padding: 22px 0 0 0; }
    .st-breadcrumb-inner { padding: 0 16px; gap: 6px; }
    .st-bc-item          { font-size: 14px; }
    .st-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .st-inner            { padding: 0 16px; }
    .st-divider          { padding: 0px 16px; }
    .st-divider-slim     { padding: 30px 16px 0 16px; }
    .st-section-content  { padding: 60px 0 0 0; }
    .st-section-content:last-child { padding: 60px 0 0px 0; }
    .st-divider:last-child { display: none; }
    .st-content-grid:last-child { margin-bottom: 60px !important; }
    .st-content-grid     { gap: 30px; flex-direction: column-reverse !important; }
    .st-img-wrap         { max-height: 260px; }
    .st-red-title        { font-size: 20px; margin-bottom: 10px; }
    .st-subtitle         { font-size: 16px; margin-bottom: 10px; }
    .st-para             { font-size: 14px; }
    .st-features-list li { font-size: 14px; }
  }
`;

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const SUBNAV = [
  {
    label: "HP Series",
    chevron: true,
    href: "/power-surveillance/hp-series",
    children: [
      { label: "HP SERIES (1 KVA To 3 KVA ONLINE UPS)", href: "/power-surveillance/hp-series#hp-product-1" },
      { label: "HP SERIES (6 KVA To 10 KVA)",           href: "/power-surveillance/hp-series#hp-product-2" },
      { label: "HP SERIES (10 KVA To 20 KVA)",          href: "/power-surveillance/hp-series#hp-product-3" },
    ],
  },
  { label: "Prime & Master Series", chevron: false, href: "/power-surveillance/prime-master-series" },
  {
    label: "Liferaft Modular",
    chevron: true,
    href: "/power-surveillance/liferaft-modular",
    children: [
      { label: "Liferaft Modular 25kVA To 400kVA", href: "/power-surveillance/liferaft-modular#lm-product-1" },
      { label: "Liferaft Modular 25kVA To 600kVA", href: "/power-surveillance/liferaft-modular#lm-product-2" },
    ],
  },
  { label: "Power+ Series", chevron: false, href: "/power-surveillance/power-plus-series" },
  { label: "Liferaft",      chevron: false, href: "/power-surveillance/liferaft" },
  {
    label: "Star+ Tx Series",
    chevron: true,
    active: true,
    href: "/power-surveillance/star-tx-series",
    children: [
      { label: "STAR Tx SERIES (6 KVA – 40 KVA)",    anchor: "st-product-1", active: true },
      { label: "STAR+ Tx SERIES (10 KVA – 300 KVA)",  anchor: "st-product-2" },
    ],
  },
  { label: "Star+ Series",                                   chevron: false, href: "/power-surveillance/star-plus-series" },
  { label: "Star+ Series Microcontroller Based Stabilizers", chevron: false, href: "/power-surveillance/star-plus-series-microcontroller-stabilizers" },
];

const PRODUCTS = [
  {
    id: 1,
    anchor: "st-product-1",
    title:    "STAR  Tx SERIES (6 KVA – 40 KVA)",
    subtitle: "Micro Controlled ONLINE Double Conversion UPS 3:1 Phase PF : 0.7",
    paras: [
      "Ador Star+ Tx series are true online, double conversion UPS systems manufactured with the state of the art, PWM  and IGBT technology, producing microprocessor controlled pure sinewave output to critical load.",
    ],
    features: [
      "Output isolation transformer",
      "Up to 91% efficiency",
      "Static by-pass",
      "LCD front panel",
      "64 event memory",
      "RS232 and relay contacts",
      "Custom input and output voltage ranges",
      "SNMP compatible communication",
      "T-MON remote monitoring software",
      "Parallel operation up to 4 devices",
      "Manufactured according to EC Directive; EN62040",
      "Compatible with Lithium-ion Battery and BMS",
    ],
    imgRight: true,
    imgSrc: StarTx1Img,
  },
  {
    id: 2,
    anchor: "st-product-2",
    title:    "STAR+ Tx SERIES (10 KVA – 300 KVA)",
    subtitle: "3:3 Phase PF : 0.8",
    paras: [
      "Ador Star+ Tx series are, true online, double conversion UPS systems manufactured with the state of the art, PWM  and IGBT technology, producing microprocessor controlled pure sinewave output to critical load.",
    ],
    features: [
      "Output isolation transformer",
      "Up to 91% efficiency",
      "Static by-pass",
      "LCD front panel",
      "128 events alarm memory (4000 alarms)",
      "RS232 and relay contacts",
      "Custom input and output voltage ranges",
      "SNMP compatible communication",
      "T-MON remote monitoring software",
      "Parallel operation up to 4 devices",
      "High performance at non linear loads",
      "Custom input voltage and frequency range",
      "Manufactured according to EC Directive; EN62040",
      "Compatible with Lithium-ion Battery and BMS",
    ],
    imgRight: false,
    imgSrc: StarTx2Img,
  },
];

/* ── SubnavItem — position:absolute dropdown, hover ── */
function SubnavItem({ item }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <div className="st-subnav-item">
        <a href={item.href || "#"} className={`st-subnav-link${item.active ? " st-active" : ""}`}>
          {item.label}
        </a>
      </div>
    );
  }

  return (
    <div
      className="st-subnav-item"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <a href={item.href || "#"} className={`st-subnav-link${item.active ? " st-active" : ""}`}>
        {item.label}
        <span className={`st-subnav-chevron${open ? " open" : ""}`} />
      </a>
      {open && (
        <div className="st-subnav-dropdown">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`st-subnav-dropdown-item${child.active ? " st-dd-active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  scrollTo(child.anchor);
                }
                setOpen(false);
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

/* ── SidebarRow ── */
function SidebarRow({ item, onClose }) {
  const [open, setOpen] = useState(item.active && item.children?.length > 0);

  if (!item.chevron || !item.children?.length) {
    return (
      <a href={item.href || "#"} className={`st-sidebar-row${item.active ? " active" : ""}`} onClick={onClose}>
        {item.label}
      </a>
    );
  }

  return (
    <>
      <button
        className={`st-sidebar-row${item.active ? " active" : ""}`}
        onClick={() => setOpen(o => !o)}
      >
        {item.label}
        <span className={`st-sidebar-chevron${open ? " open" : ""}`} />
      </button>
      {open && (
        <div className="st-sidebar-subitems">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`st-sidebar-subitem${child.active ? " active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  onClose();
                  setTimeout(() => scrollTo(child.anchor), 320);
                } else {
                  onClose();
                }
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </>
  );
}

export default function StarTxSeries() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    if (!hash) return;
    const tryScroll = () => {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        setTimeout(tryScroll, 100);
      }
    };
    const timer = setTimeout(tryScroll, 300);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <style>{CSS}</style>

      {/* HERO */}
      <div className="st">
        <section className="st-hero">
          <img className="st-hero-bg" src={HeroBgImg} alt="" />
          <img className="st-hero-bg-mobile" src={HeroMobileImg} alt="" />
          <div className="st-hero-content">
            <h1 className="st-hero-title">
              UNINTERRUPTED <em>POWER</em>,<br />
              UNMATCHED <em>VISION</em>
            </h1>
          </div>
        </section>
      </div>

      {/* SUBNAV outside .st */}
      <nav className="st-subnav" aria-label="Product categories">
        <div className="st-subnav-inner">
          {SUBNAV.map((item, i) => (
            <SubnavItem key={i} item={item} />
          ))}
        </div>
      </nav>

      {/* MOBILE BAR outside .st */}
      <div className="st-mobile-bar">
        <span className="st-mobile-bar-title">Star+ Tx Series</span>
        <button className="st-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
          <span /><span /><span />
        </button>
      </div>

      {/* MOBILE SIDEBAR */}
      <div
        className={`st-sidebar-overlay${sidebarOpen ? " open" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />
      <div className={`st-sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="st-sidebar-header">
          <span className="st-sidebar-header-title">Star+ Tx Series</span>
          <button className="st-sidebar-close" onClick={() => setSidebarOpen(false)}>✕</button>
        </div>
        <nav className="st-sidebar-nav">
          {SUBNAV.map((item, i) => (
            <SidebarRow key={i} item={item} onClose={() => setSidebarOpen(false)} />
          ))}
        </nav>
      </div>

      {/* REST OF PAGE */}
      <div className="st">
        <nav className="st-breadcrumb" aria-label="Breadcrumb">
          <div className="st-breadcrumb-inner">
            <a href="/" className="st-bc-item">Home</a>
            <span className="st-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <a href="#" className="st-bc-item">Business</a>
            <span className="st-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <span className="st-bc-item active">Power &amp; Surveillance</span>
          </div>
        </nav>

        <div className="st-divider-slim"><hr /></div>

        {PRODUCTS.map((product) => (
          <React.Fragment key={product.id}>
            <div id={product.anchor} className="st-anchor" />
            <section className="st-section-content">
              <div className="st-inner">
                <div
                  className="st-content-grid"
                  style={!product.imgRight ? { flexDirection: "row-reverse" } : {}}
                >
                  <div className="st-content-left">
                    <h2 className="st-red-title">{product.title}</h2>
                    <h3 className="st-subtitle">{product.subtitle}</h3>
                    {product.paras.map((p, i) => (
                      <p key={i} className="st-para">{p}</p>
                    ))}
                    <div className="st-features-tag">
                      <div className="st-features-tag-bar" />
                      <span className="st-features-tag-text">Features</span>
                    </div>
                    <ul className="st-features-list">
                      {product.features.map((f, i) => <li key={i}>{f}</li>)}
                    </ul>
                  </div>

                  <div className="st-img-col">
                    <div className="st-img-wrap">
                      {product.imgSrc &&
                        <img className="st-product-img" src={product.imgSrc} alt={product.title} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="st-divider"><hr /></div>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}